
/**
 * Dependencies:
 *  - jQuery
 */

const Scroll = {

    init: () => {
        jQuery(document).on('click', 'a[href^="#"]', function (event) {
            event.preventDefault();
            jQuery('html, body').animate({
                scrollTop: jQuery(jQuery.attr(this, 'href')).offset().top
            }, 500);
        });
    }

}

export default Scroll;
